// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"_125qv","withSvgCoreBadge":"_125qv"};